//@ts-nocheck
import { Input } from 'antd';
import React, { forwardRef } from 'react';
import Label from './Label';
import HelperText from './HelperText';
import cn from 'classnames';

type Props = {
  length?: number;
  id: string;
  label?: string;
  helperText?: string;
  status?: 'error' | 'success';
  disabled?: boolean;
  required?: boolean;
  labelHelperText?: string;
} & Omit<React.ComponentProps<typeof Input.OTP>, 'status'>;

const InputOTP = forwardRef<HTMLInputElement, Props>(
  (
    {
      length = 5,
      id,
      label,
      helperText,
      status,
      disabled,
      labelHelperText,
      required,
      size = 'small',
      ...props
    }: Props,
    ref
  ) => {
    return (
      <div className="otp-input flex flex-col">
        {label && (
          <Label
            labelHelperText={labelHelperText}
            required={required}
            htmlFor={id}
            text={label}
          />
        )}
        <div
          className={cn('', {
            'otp-success': status === 'success',
            'otp-error': status === 'error',
            disabled: disabled,
          })}
        >
          <Input.OTP
            disabled={disabled}
            size={size}
            id={id}
            length={length}
            autoFocus
            {...props}
            ref={ref}
          />
        </div>
        {helperText && (
          <HelperText status={status} disabled={disabled} text={helperText} />
        )}
      </div>
    );
  }
);

InputOTP.displayName = 'InputOTP';

export default InputOTP;
